[
  {
    "id": "free",
    "name": "Free",
    "subscriber_count": 100,
    "url": "",
    "price": 0,
    "features": [
      "scheduling",
      "archives",
      "custom_sending_domain",
      "markdown",
      "smtp_endpoint",
      "api",
      "firewall"
    ]
  },
  {
    "id": "basic",
    "name": "Basic",
    "subscriber_count": 1000,
    "url": "https://buy.stripe.com/3cs2aE9xZfSR6aIbIO",
    "price": 9,
    "features": [
      "scheduling",
      "paid_subscriptions",
      "custom_sending_domain",
      "smtp_endpoint",
      "api",
      "tags",
      "forms","surveys",
      "metadata",
      "customer_service",
      "rss_automation",
      "concierge_migration",
      "attachments",
      "analytics",
      "comments",
      "css",
      "archives",
      "markdown",
      "firewall",
      "integrations",
      "subscriber_cleanup"
    ]
  },
  {
    "id": "standard",
    "name": "Standard",
    "subscriber_count": 5000,
    "url": "https://buy.stripe.com/9AQ7uYfWncGF7eMeUZ",
    "price": 29,
    "features": [
      "scheduling",
      "paid_subscriptions",
      "custom_sending_domain",
      "api",
      "smtp_endpoint",
      "tags",
      "metadata",
      "concierge_migration",
      "customer_service",
      "rss_automation",
      "attachments",
      "analytics",
      "comments",
      "forms","surveys",
      "custom_domain",
      "css",
      "archives",
      "multiple_newsletters",
      "webhooks",
      "zapier",
      "markdown",
      "automations",
      "firewall",
      "integrations",
      "custom_transactional_emails",
      "sponsorships",
      "subscriber_cleanup"
    ]
  },
  {
    "id": "professional",
    "name": "Professional",
    "subscriber_count": 10000,
    "url": "https://buy.stripe.com/9AQ16AfWndKJdDa007",
    "price": 79,
    "features": [
      "scheduling",
      "paid_subscriptions",
      "custom_sending_domain",
      "api",
      "tags",
      "automations",
      "metadata",
      "whitelabeling",
      "customer_service",
      "forms","surveys",
      "rss_automation",
      "comments",
      "attachments",
      "multiple_newsletters",
      "analytics",
      "custom_domain",
      "css",
      "archives",
      "concierge_migration",
      "webhooks",
      "smtp_endpoint",
      "zapier",
      "teams",
      "dedicated_ip",
      "markdown",
      "naked_mode",
      "firewall",
      "integrations",
      "custom_transactional_emails",
      "sponsorships",
      "subscriber_cleanup"
    ]
  },
  {
    "id": "advanced",
    "name": "Advanced",
    "subscriber_count": 20000,
    "url": "https://buy.stripe.com/eVaaHafWncGF8iQ6os",
    "price": 139,
    "features": [
      "scheduling",
      "paid_subscriptions",
      "api",
      "custom_sending_domain",
      "tags",
      "concierge_migration",
      "metadata",
      "customer_service",
      "forms","surveys",
      "smtp_endpoint",
      "rss_automation",
      "attachments",
      "multiple_newsletters",
      "comments",
      "analytics",
      "custom_domain",
      "css",
      "archives",
      "webhooks",
      "whitelabeling",
      "zapier",
      "teams",
      "dedicated_ip",
      "markdown",
      "automations",
      "naked_mode",
      "firewall",
      "integrations",
      "custom_transactional_emails",
      "sponsorships",
      "subscriber_cleanup"
    ]
  },
  {
    "id": "enterprise",
    "name": "Enterprise",
    "subscriber_count": 999999,
    "url": "mailto:concierge@buttondown.com",
    "price": 999999,
    "features": [
      "scheduling",
      "paid_subscriptions",
      "custom_sending_domain",
      "api",
      "tags",
      "smtp_endpoint",
      "metadata",
      "customer_service",
      "rss_automation",
      "comments",
      "attachments",
      "multiple_newsletters",
      "concierge_migration",
      "analytics",
      "custom_domain",
      "css",
      "forms","surveys",
      "archives",
      "webhooks",
      "whitelabeling",
      "zapier",
      "teams",
      "dedicated_ip",
      "markdown",
      "automations",
      "naked_mode",
      "firewall",
      "integrations",
      "custom_transactional_emails",
      "sponsorships",
      "subscriber_cleanup"
    ]
  }
]
